var isNumeric = function (obj) {
  obj = typeof obj === "string" ? obj.replace(/,/g, "") : obj;
  return !isNaN(parseFloat(obj)) && isFinite(obj) && Object.prototype.toString.call(obj).toLowerCase() !== "[object array]";
};
if (typeof exports !== "undefined") {
  if (typeof module !== "undefined" && module.exports) {
    exports = module.exports = isNumeric;
  }
  exports.isNumeric = isNumeric;
}